module.exports = __webpack_public_path__ + "img/hr-tank-turret-shadow.7f0ebeeb.png";